<footer class="app-footer" idle-animation>
  <nav class="app-footer__links" aria-label="Legal">
    <button type="button" class="footer-link" click.trigger="ui.openLegal('terms')">Terms &amp; Conditions</button>
    <span class="footer-sep" aria-hidden="true">·</span>
    <button type="button" class="footer-link" click.trigger="ui.openLegal('privacy')">Privacy Policy</button>
    <span class="footer-sep" aria-hidden="true">·</span>
    <button type="button" class="footer-link" click.trigger="ui.openLegal('disclaimer')">Disclaimer</button>
    <span class="footer-sep" aria-hidden="true">·</span>
    <a class="footer-link footer-link--icon" href="https://www.facebook.com/toyscalendar" target="_blank" rel="noopener noreferrer" aria-label="Toy Calendar on Facebook" title="Toy Calendar on Facebook">
      <svg class="footer-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.09 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.09 24 18.1 24 12.07z" />
      </svg>
    </a>
    <span class="footer-sep" aria-hidden="true">·</span>
    <a class="footer-link footer-link--icon" href="https://x.com/ToysCalendar" target="_blank" rel="noopener noreferrer" aria-label="Toy Calendar on X" title="Toy Calendar on X">
      <svg class="footer-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817-5.964 6.817H1.684l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    </a>
    <span class="footer-sep" aria-hidden="true">·</span>
    <a class="footer-link footer-link--icon" href="https://www.instagram.com/toy.calendar/" target="_blank" rel="noopener noreferrer" aria-label="Toy Calendar on Instagram" title="Toy Calendar on Instagram">
      <svg class="footer-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
        <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4zm9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6" />
      </svg>
    </a>
  </nav>
  <div class="app-footer__copyright">© ${ui.currentYear} Toy Calendar. All rights reserved.</div>
  <div class="app-footer__note">
    Toy Calendar is an independent, non-commercial project and is not affiliated with, endorsed by, or
    sponsored by any toy manufacturer or retailer. Product names, images, and trademarks are the property of their
    respective owners.
  </div>
  <div class="app-footer__made-in">
    <svg class="pr-flag" viewBox="0 0 300 200" role="img" aria-label="Puerto Rico flag">
      <rect width="300" height="200" fill="#fff" />
      <rect width="300" height="40" y="0" fill="#ed0000" />
      <rect width="300" height="40" y="80" fill="#ed0000" />
      <rect width="300" height="40" y="160" fill="#ed0000" />
      <path d="M0 0 L173.2 100 L0 200 Z" fill="#0050f0" />
      <path fill="#fff" d="M57.7 68.5 L69.7 105.4 L38.3 82.6 L77.1 82.6 L45.7 105.4 Z" />
    </svg>
    <span>MADE IN PR</span>
  </div>
</footer>
